import styled from 'styled-components'


export const Wrap = styled.div`
  background-color: #1994D8;
`;